import "./ResponsiveSystemLocation.css";
import "./SystemLocation.css";
import { getTranslatedText as translate } from "../../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";

const SystemLocation = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));
  const locations = [
    {
      id: 1,
      name: "المنزل",
      city: "الرياض",
      building: 4,
      floor: 2,
    },
    {
      id: 2,
      name: "العمل",
      city: "الرياض",
      building: 1,
      floor: 6,
    },
    {
      id: 3,
      name: "العطلة",
      city: "جدة",
      building: 2,
      floor: 1,
    },
  ];

  const locationList = locations.map((location) => {
    return (
      <tr className="location-row-table" key={location.id}>
        <th>{location.id}</th>
        <td>{location.name}</td>
        <td>{location.city}</td>
        <td>{location.building}</td>
        <td>{location.floor}</td>
      </tr>
    );
  });

  return (
    <div className="System-Location-component">
      {/* <form>
                <div className="mb-3">
                    <label htmlFor="InputLocationSettings" className="form-label">{translate('system-location-change-label', locale)}</label>
                    <input type="password" className="form-control" id="InputLocationSettings" />
                    <div id="InputLocationSettings" className="form-text">{translate('system-location-change-note', locale)}</div>
                </div>
                <div className="mb-3 form-check" style={{ display: 'flex', justifyContent: 'center', width: 'fit-content', gap: '10px' }}>
                    <input type="checkbox" className="" id="autoLocationSettings" />
                    <label className="form-check-label" htmlFor="autoLocationSettings">{translate('system-location-btn-auto-label', locale)}</label>
                </div>
                <button type="submit" className="btn btn-primary">{translate('system-location-btn-change-label', locale)}</button>
            </form> */}
      <table className="table" dir="auto">
        <thead className="thead-dark">
          <tr className="table-notification-details-header">
            <th scope="col">#</th>
            <th scope="col">اسم الموقع</th>
            <th scope="col">{translate("choose-city", locale)}</th>
            <th scope="col">{translate("building-number", locale)}</th>
            <th scope="col">{translate("floor-number", locale)}</th>
          </tr>
        </thead>
        <tbody>
          {locationList}
          <tr className="location-row-table">
            <th className="col-md-1">
              <button type="submit" className="btn btn-primary flex-btn">
                <i className="bi bi-plus-lg"></i>
                إضافة
              </button>
            </th>
            <td className="col-md-2">
              <input
                type="text"
                className="form-control"
                id="inputZip"
                placeholder="اسم الموقع"
              />
            </td>
            <td className="col-md-2">
              <select id="inputState" className="form-control">
                <option>{translate("choose-city", locale)}</option>
                <option>...</option>
              </select>
            </td>
            <td className="col-md-2">
              <input
                type="number"
                className="form-control"
                id="inputCity"
                placeholder={translate("building-number", locale)}
              />
            </td>
            <td className="col-md-2">
              <input
                type="number"
                className="form-control"
                id="inputZip"
                placeholder={translate("floor-number", locale)}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SystemLocation;
